import { NAV_PATH } from '../../lib/nav';
import type { PageRoute } from '../../page-route';
import { RulesPage } from './page';

export const route: PageRoute = { path: NAV_PATH.rules, access: 'authed', Component: RulesPage };
